import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Header.css';
import logo from '../../assets/logo.png';
import getInTouchBtn from '../../assets/get-in-touch-btn.png';
import userIcon from '../../assets/user-icon.png';
import ContactModal from '../ContactModal';
import { track } from '../../analytics/analytics';
import { EVENTS } from '../../analytics/events';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userName, setUserName] = useState('');

  const isDashboardPage = location.pathname === '/dashboard';
  const isLegalPage = location.pathname === '/privacy' || location.pathname === '/terms' || location.pathname === '/sms-consent' || location.pathname === '/contact';

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Check authentication status
  useEffect(() => {
    const checkAuth = () => {
      const authStatus = localStorage.getItem('isAuthenticated');
      const userData = localStorage.getItem('user');

      if (authStatus === 'true' && userData) {
        setIsAuthenticated(true);
        try {
          const user = JSON.parse(userData);
          setUserName(user.fullName || user.email || 'User');
        } catch (error) {
          console.error('Error parsing user data:', error);
        }
      } else {
        setIsAuthenticated(false);
        setUserName('');
      }
    };

    checkAuth();

    // Listen for storage changes (for logout in other tabs)
    window.addEventListener('storage', checkAuth);
    return () => window.removeEventListener('storage', checkAuth);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const openModal = () => {
    setIsModalOpen(true);
    setIsMenuOpen(false);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const scrollToSection = (sectionId) => {
    setIsMenuOpen(false);
    if (location.pathname !== '/') {
      sessionStorage.setItem('pendingScrollSection', sectionId);
      navigate('/');
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  // After navigating back to home, scroll to the pending section
  useEffect(() => {
    if (location.pathname === '/') {
      const pending = sessionStorage.getItem('pendingScrollSection');
      if (pending) {
        sessionStorage.removeItem('pendingScrollSection');
        setTimeout(() => {
          const element = document.getElementById(pending);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 300);
      }
    }
  }, [location.pathname]);

  const handleLogoClick = () => {
    navigate('/');
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  const handleLogout = () => {
    // Clear authentication data
    localStorage.removeItem('user');
    localStorage.removeItem('isAuthenticated');
    sessionStorage.removeItem('agentVerificationData');
    sessionStorage.removeItem('inviteData');

    // Update state
    setIsAuthenticated(false);
    setUserName('');
    setIsMenuOpen(false);

    // Navigate to home page
    navigate('/');
  };

  return (
    <>
      <header className={`header ${(isScrolled || isLegalPage) ? 'scrolled' : ''} ${isDashboardPage ? 'dashboard-header-style' : ''}`}>
        <div className="header-container">
          <nav className="navbar">
            <div className="logo" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
              <div className="logo-icon">
                <img src={logo} alt="Rialty.AI Logo" />
              </div>
              <div className="logo-text">
                <span className="logo-title">RIALTY.AI</span>
                <span className="logo-subtitle">LEADING TRANSACTIONS FOR YOU</span>
              </div>
            </div>

            <button className="menu-toggle" onClick={toggleMenu} aria-label="Toggle menu">
              <span></span>
              <span></span>
              <span></span>
            </button>

            <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
              <li><a onClick={() => scrollToSection('how-ria-helps')}>How Ria helps</a></li>
              <li><a onClick={() => scrollToSection('users')}>Our Users</a></li>
              <li><a onClick={() => scrollToSection('team')}>Team</a></li>
              <li><a onClick={() => scrollToSection('about')}>About us</a></li>

              {isAuthenticated ? (
                <>
                  {/* <li className="user-greeting">
                    <span>Hi, {userName}</span>
                  </li> */}
                  {/* <li>
                    <button className="btn-profile" onClick={() => navigate('/profile')}>
                      Profile
                    </button>
                  </li> */}
                  <li>
                    <button className="btn-logout" onClick={handleLogout}>
                      Logout
                    </button>
                  </li>
                </>
              ) : (
                <li className="user-icon-header">
                  <a
                    onClick={() => {
                      track(EVENTS.CTA_CLICK, { element_label: 'login', source_screen: location.pathname });
                      navigate('/login');
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    <img src={userIcon} alt="User" className="user-icon-img" />
                  </a>
                </li>
              )}

              <li>
                <img
                  src={getInTouchBtn}
                  alt="Get in touch"
                  className="btn-get-in-touch-img"
                  onClick={openModal}
                />
              </li>
            </ul>
          </nav>
        </div>
      </header>
      <ContactModal isOpen={isModalOpen} onClose={closeModal} />
    </>
  );
};

export default Header;
